export default "__VITE_ASSET__OpZ$bWU0__"